import React from 'react';
import { Box, Text } from 'ink';

interface ProgressBarProps {
    current: number;
    total: number;
    width?: number;
    showPercentage?: boolean;
    color?: string;
}

/**
 * ASCII progress bar component
 */
export const ProgressBar: React.FC<ProgressBarProps> = ({
    current,
    total,
    width = 40,
    showPercentage = true,
    color = 'cyan',
}) => {
    const percentage = total > 0 ? Math.round((current / total) * 100) : 0;
    const filled = Math.round((percentage / 100) * width);
    const empty = width - filled;

    const bar = '█'.repeat(filled) + '░'.repeat(empty);

    return (
        <Box>
            <Text color={color}>{bar}</Text>
            {showPercentage && (
                <Text dimColor> {current}/{total} ({percentage}%)</Text>
            )}
        </Box>
    );
};
